import React, { forwardRef, memo } from 'react'

const ToolEadIcon = forwardRef<SVGSVGElement, React.SVGProps<SVGSVGElement>>(
  (props, ref) => (
    <svg
      ref={ref}
      width="58.8"
      height="58.8"
      viewBox="0 0 84 84"
      fill="none"
      {...props}>
      <circle cx="41.9496" cy="41.9496" r="41.9496" fill="#78BE20" />
      <path
        d="M40.875 40.1252L45.875 45.1252"
        stroke="white"
        strokeWidth="3"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M59.6346 37.6154L53.3752 43.8747"
        stroke="white"
        strokeWidth="3"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M30.2504 32L32.402 29.7765C33.6788 28.4995 35.1947 27.4865 36.8631 26.7954C38.5314 26.1043 40.3196 25.7485 42.1254 25.7485C43.9313 25.7485 45.7195 26.1043 47.3878 26.7954C49.0562 27.4865 50.5721 28.4995 51.8489 29.7765L62.3848 40.3844C62.6191 40.6187 62.7507 40.9366 62.7507 41.2679C62.7507 41.5993 62.6191 41.9171 62.3848 42.1515L57.9067 46.6344C57.6723 46.8686 57.3545 47.0002 57.0231 47.0002C56.6917 47.0002 56.3739 46.8686 56.1395 46.6344L50.2504 40.75L34.3661 56.6344C34.1317 56.8686 33.8139 57.0002 33.4825 57.0002C33.1511 57.0002 32.8333 56.8686 32.5989 56.6344L29.3661 53.4062C29.1318 53.1718 29.0002 52.854 29.0002 52.5226C29.0002 52.1913 29.1318 51.8734 29.3661 51.639L45.2504 35.75L36.4661 26.9656"
        stroke="white"
        strokeWidth="3"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
)

ToolEadIcon.displayName = 'ToolEadIcon'

export default memo(ToolEadIcon)
